import { render, staticRenderFns } from "./SearchProjects.vue?vue&type=template&id=c3c3f858&"
import script from "./SearchProjects.vue?vue&type=script&lang=js&"
export * from "./SearchProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports